// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ih5fI","content":"styles_content__Jp3Ar","row":"styles_row__3kBKA","footer":"styles_footer__2qLb0","phraseLength":"styles_phraseLength__2gW3A"};